'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validators = require('vuelidate/lib/validators');

exports.default = {
    data: function data() {
        return {
            newpassword: '',
            newpasswordrepeat: '',
            key: '',
            manualusername: ''
        };
    },

    mounted: function mounted() {
        this.$v.newpassword.$reset();
        this.$v.newpasswordrepeat.$reset();
    },
    validations: {
        newpassword: {
            required: _validators.required,
            minLength: (0, _validators.minLength)(8),
            pattern: function pattern(value) {
                var pattern = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[#?!@$%^&*-\\/><+;:)(=])(?=\\S+$).{8,}$");
                return pattern.test(value);
            }
        },
        newpasswordrepeat: {
            required: _validators.required,
            minLength: (0, _validators.minLength)(8),
            pattern: function pattern(value) {
                var pattern = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[#?!@$%^&*-\\/><+;:)(=])(?=\\S+$).{8,}$");
                return pattern.test(value);
            },

            sameAsPassword: (0, _validators.sameAs)('newpassword')
        }
    },
    computed: {
        isPrefilled: function isPrefilled() {
            return this.prefilled === 'true';
        }
    },
    methods: {
        save: function save() {
            if (this.$v.$invalid === true) {
                this.$v.newpassword.$touch();
                this.$v.newpasswordrepeat.$touch();
            } else {
                var self = this;

                var uri = this.submitUrl;
                var successUrl = this.successUrl;

                var token = void 0;
                var username = void 0;

                if (this.isPrefilled == false) {
                    token = this.key;
                    username = this.manualusername;
                } else {
                    token = this.token;
                    username = this.username;
                }

                var postValues = {
                    key: token,
                    username: username,
                    newpassword: this.newpassword,
                    newpasswordrepeat: this.newpasswordrepeat
                };

                this.axios.post(uri, postValues).then(function (response) {
                    if (response.data.success) {
                        window.location.href = successUrl;
                    } else {
                        if (response.data.flashMessage.length > 0) {
                            self.$notify({
                                title: 'Failed',
                                message: response.data.flashMessage,
                                type: 'error',
                                offset: 150,
                                customClass: 'error'
                            });
                        }
                        if (response.data.validationErrors.length > 0) {

                            var errorFields = response.data.validationErrors;
                            var errorFieldNames = Object.keys(errorFields);
                            var totalErrorFieldNames = errorFieldNames.length;

                            for (var i = 0; i < totalErrorFieldNames; i++) {
                                console.log(errorFieldNames[ii]);
                            }
                        }
                    }
                }).catch(function (error) {
                    if (error.response != 'undefined' && error.response.status >= 500 || error.message === "Network Error") {
                        self.$notify({
                            title: 'Update failed',
                            message: 'Due to network or server problems, your request could not be processed. Please try again later.',
                            type: 'error',
                            offset: 150
                        });
                    } else {
                        console.error(error);
                    }
                });
            }
        }
    },
    props: ['submitUrl', 'successUrl', 'prefilled', 'username', 'token']
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/my-account-validate.vue
// module id = ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/my-account-validate.vue
// module chunks = 0